import React, { createContext, useContext } from 'react';
import ReactDOM from 'react-dom';
import styled from '@emotion/styled';
import { useAccessibilityContext } from '@vmos2/providers';

export const HeaderContext = createContext();
export const HeaderPortal = ({ children }: { children: React.Node }) => {
  const { a11yMode } = useAccessibilityContext();

  const { current } = useContext(HeaderContext);
  if (!current) return null;
  return ReactDOM.createPortal(<Container isA11yMode={!!a11yMode}>{children}</Container>, current);
};

const Container = styled('div')`
  margin-bottom: ${({ theme, isA11yMode }) => !isA11yMode && theme.constants.headerHeight};
`;
